module.exports = __webpack_public_path__ + "img/taochi1.98164cd8.jpg";